var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebaseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 104,
    viewBox: "0 0 83 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8851 99.2302C45.9929 106.424 30.5295 102.228 24.5343 99.2302L12.4407 47.4444L22.3637 41.8627L29.1858 38.4517L59.8851 64.1895V99.2302Z",
    fill: "#056945"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7383 91.1677C92.4449 68.2207 80.0411 42.793 70.7383 32.5599L57.4042 15.8148L43.7601 0C29.3717 9.42687 23.8442 28.2186 22.6736 37.5214C17.9602 74.9808 44.8971 94.4754 58.9547 99.5403C63.172 98.0518 68.8792 93.133 70.7383 91.1677Z",
    fill: "url(#paint0_linear_535_615)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9454 44.0334C60.5053 63.5693 41.8997 92.7182 26.3949 100.47C-7.34336 83.3533 -1.82358 51.4756 5.61859 41.2425C15.5416 40.3122 24.2242 41.8007 27.9454 44.0334Z",
    fill: "url(#paint1_linear_535_615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_535_615",
    x1: 52.4637,
    y1: 0,
    x2: 52.4637,
    y2: 99.5403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_535_615",
    x1: 36.9381,
    y1: 63.2592,
    x2: 22.9681,
    y2: 100.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebaseLogo);
export default __webpack_public_path__ + "static/media/firebase-logo.7db2db2bfce9222ec0d7b7ce9a8d64c9.svg";
export { ForwardRef as ReactComponent };